var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showTutorialButton)?_c('div',{staticClass:"education-button",on:{"click":_vm.onOpenVideo}},[_c('i'),_c('p',[_vm._v("Tutorial")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }